import {Dispatch} from "redux";
import {AdminApiActionTypes, AdminApiAction} from "../../../../types/admins/operators/admin/adminApiTypes";
import axios from "axios";


export const getAdminApiData = (id:string): any => {
    return async (dispatch: Dispatch<AdminApiAction>) => {
        try {
            dispatch({type: AdminApiActionTypes.FETCH_ADMIN_API_DATA});
            const response = await axios({
                method: 'get',
                url: `/api/operators/${id}/api_settings`,
                withCredentials: false
            });
            dispatch({type: AdminApiActionTypes.FETCH_ADMIN_API_DATA_SUCCESS, payload: response.data})
        } catch (error) {
            dispatch({type: AdminApiActionTypes.FETCH_ADMIN_API_DATA_ERROR, payload: 'Something wend wrong check Admin API action controller'});
        }
    }
}